<template>
  <div
    class="ms-message-box"
    @keydown.esc="escPress($event, $close)"
  >
    <div
      ref="msg"
      class="msg-center"
      :style="{ width: width + 'px' }"
    >
      <div class="msg-title">
        {{ title }}
      </div>
      <div
        v-if="!hideClose"
        class="msg-close icon24 close"
        @click="$close(this, null)"
      />
      <div class="msg-message">
        <template v-if="Array.isArray(message)">
          <div
            v-for="(item, i) in message"
            :key="i"
            class="msg-item"
            v-html="item"
          />
        </template>
        <div
          v-else
          class="msg-item"
          v-html="message"
        />
        <!-- confirm không hiện lại popup này lần sau -->
        <div
          v-if="showCheckbox"
          class="mt-2 mb-1"
        >
          <ms-checkbox
            v-model="isChecked"
            :label="labelCheckbox || $t('i18nComponent.MessageBox.NotShowAgain')"
          />
        </div>
      </div>

      <!-- alert -->
      <div
        v-if="type == $ms.constant.MessageBoxType.Alert"
        class="msg-buttons flex-end"
      >
        <button
          class="msg-btn btn primary"
          @click="$close(this, true)"
        >
          {{ confirmButtonText }}
        </button>
      </div>
      <!-- confirm-->
      <div
        v-else
        class="msg-buttons flex-row"
      >
        <div class="flex" />
        <button
          v-if="showCancelButton"
          class="msg-btn btn secondary-outline"
          @click="$close(this, false)"
        >
          {{ cancelButtonText }}
        </button>
        <button
          v-if="showConfirmButton"
          :class="`msg-btn btn ${confirmButtonType}`"
          @click="$close(this, true)"
        >
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, ref } from 'vue'
import commonFn from '@/commons/commonFunction'
import MsCheckbox from '../checkbox/MsCheckbox.vue'
import i18n from '@/i18ns/i18n'

const $t = i18n.global.t

export default {
  components: { MsCheckbox },
  props: {
    /**
     * Tiêu đề
     */
    title: {
      type: String,
      default: $t('i18nCommon.command.notification'),
    },
    /**
     * kích thước
     */
    width: {
      type: Number,
      default: 400,
    },
    /**
     * Nội dung
     */
    message: {
      type: [String, Array],
      default: null,
    },
    /**
     * Thuộc loại nào
     */
    type: {
      type: Number,
      default: 0,
    },
    /**
     * có show icon close không
     */
    showClose: {
      type: Boolean,
      default: true,
    },
    /**
     * Có show button confirm không
     */
    showConfirmButton: {
      type: Boolean,
      defaul: true,
    },
    /**
     * Có show button cancel không
     */
    showCancelButton: {
      type: Boolean,
      defaul: true,
    },
    /**
     * Text button confirm không
     */
    confirmButtonText: {
      type: String,
      default: $t('i18nComponent.MessageBox.Accept'),
    },
    /**
     * Text button cancel không
     */
    cancelButtonText: {
      type: String,
      default: $t('i18nComponent.MessageBox.No'),
    },
    /**
     * Loại button confirm không
     */
    confirmButtonType: {
      type: String,
      default: 'primary',
    },
    /**
     * có show check box không
     */
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    /**
     * label check box
     */
    labelCheckbox: {
      type: String,
      default: null,
    },
  },

  // eslint-disable-next-line no-unused-vars
  setup (props) {
    const { proxy } = getCurrentInstance()
    const isChecked = ref(true)

    onMounted(() => {
      commonFn.focusFirstControl(proxy.$refs.msg)
    })

    /**
     * Xử lý sự kiện click esc
     */
    function escPress (e, close) {
      e.preventDefault()
      close(this, null)
    }

    return {
      escPress,
      isChecked,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsMessageBox.scss';
</style>
